module.exports = __webpack_public_path__ + "static/media/bg-pattern-award-bottom.9daec339.svg";